import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { SessionService } from '../../services/session/session.service';
import { Action, Subject } from './app-ability';
import { defineAbilityFor } from './role-permissions';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
    /**
     * Reactive CASL ability — updates automatically whenever the assumed role
     * changes. Bind this in templates via the CanPipe or CanDirective.
     */
    readonly ability = toSignal(
        this.session.assumedRole$.pipe(map(role => defineAbilityFor(role))),
        { initialValue: defineAbilityFor(undefined) },
    );

    constructor(private readonly session: SessionService) {}

    /**
     * Synchronous convenience check. Safe to call inside templates of OnPush
     * components because it reads from the reactive `ability` signal — Angular
     * will re-evaluate the expression whenever the signal changes.
     */
    can(action: Action, subject: Subject): boolean {
        return this.ability().can(action, subject);
    }
}
